import { Component, OnInit, ViewChild } from '@angular/core';
import { PlanillaMensual } from 'src/app/Models/planilla/planilla-mensual';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertComponent } from '../../objects/alert/alert/alert.component';

@Component({
  selector: 'app-planilla-mensual',
  templateUrl: './planilla-mensual.component.html',
  styleUrls: ['./planilla-mensual.component.css']
})
export class PlanillaMensualComponent implements OnInit {

  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public items: any[] = [];
  public nuevo: PlanillaMensual = new PlanillaMensual();
  public agregando: boolean = false;
  public page: number = 1;
  public total: number = 0;
  public sucursales: any[] = [];

  public filtro = {
    anio: new Date().getFullYear(),
    mes: '',
    idsucursal: ''
  };

  public anios: number[] = [];

  public meses = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
  ];

  constructor(private data: DataService) { }

  ngOnInit() {
    this.GenerarAnios();
    this.GetSucursales();
    this.GetData();
  }

  GenerarAnios() {
    const actual = new Date().getFullYear();
    for (let i = actual - 3; i <= actual + 1; i++) {
      this.anios.push(i);
    }
  }

  GetSucursales() {
    this.data.GetSimple(this.data.api.sucursal).subscribe(r => {
      this.sucursales = r.data || r;
    });
  }

  GetData() {
    this.loading.show('Cargando...');
    let params = `planilla-mensual/?anio=${this.filtro.anio}`;
    if (this.filtro.mes) params += `&mes=${this.filtro.mes}`;
    if (this.filtro.idsucursal) params += `&idsucursal=${this.filtro.idsucursal}`;

    this.data.GetSimple(params).subscribe(
      r => {
        this.loading.hide();
        this.items = r.data || r;
        this.total = this.items.length;
      },
      e => { this.loading.hide(); console.log(e); }
    );
  }

  ShowNew() {
    this.nuevo = new PlanillaMensual();
    this.nuevo.idsucursal = this.data.getSucursalId();
    this.agregando = true;
  }

  CancelNew() {
    this.agregando = false;
    this.nuevo = new PlanillaMensual();
  }

  formNewValid(): boolean {
    return !!(this.nuevo.anio && this.nuevo.mes && this.nuevo.idsucursal && this.nuevo.total_planilla >= 0);
  }

  SaveNew() {
    this.data.Post('planilla-mensual', this.nuevo).subscribe(
      r => {
        this.data.notify('Planilla registrada correctamente', 'Éxito', this.data.alertType.success);
        this.agregando = false;
        this.nuevo = new PlanillaMensual();
        this.GetData();
      },
      e => {
        let msg = 'Error al guardar';
        try { msg = e.error.data.non_field_errors[0]; } catch (_) { }
        this.data.notify(msg, 'Error', this.data.alertType.error);
      }
    );
  }

  StartEdit(item: any) {
    item._backup = { ...item };
    item.editando = true;
  }

  CancelEdit(item: any) {
    Object.assign(item, item._backup);
    item.editando = false;
  }

  SaveEdit(item: any) {
    this.data.Put('planilla-mensual', item.idplanilla, item).subscribe(
      r => {
        item.editando = false;
        this.data.notify('Actualizado correctamente', 'Éxito', this.data.alertType.success);
        this.GetData();
      },
      e => {
        this.data.notify('Error al actualizar', 'Error', this.data.alertType.error);
      }
    );
  }

  ShowDelete(item: any) {
    const options = new ALertOption();
    options.confirmButtonText = 'Sí, eliminar';
    options.cancelButtonText = 'Cancelar';
    options.showCloseButton = true;

    this.data.notify(
      `¿Eliminar planilla de ${item.mes_nombre} ${item.anio}?`,
      'Confirmar eliminación',
      this.data.alertType.warning,
      options,
      () => this.Delete(item)
    );
  }

  Delete(item: any) {
    this.data.Delete('planilla-mensual', item.idplanilla).subscribe(
      r => {
        this.data.notify('Eliminado correctamente', 'Éxito', this.data.alertType.success);
        this.GetData();
      },
      e => { this.data.notify('Error al eliminar', 'Error', this.data.alertType.error); }
    );
  }

}
